import styled from '@emotion/styled';
import * as UX from '../../newux/kit';

/**
 * Temporary — the classic MUI theme's own primary color (used by these classic
 * fields'/buttons' default focus/contained/outlined states) is blue500. Until the
 * classic theme itself is updated to blue600, wrap classic MUI fields/buttons that
 * need the new color in this. Safe to delete this whole file (and its imports) once
 * that theme update lands.
 *
 * Also normalizes field text: 16px/regular weight whether the field is empty
 * (showing its placeholder) or filled — the only difference is color, grey700 for
 * the placeholder and black once filled. No select/textfield in newux style should
 * ever render at the 400/medium weight.
 */
export const ClassicBlue600 = styled('div')`
  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${UX.tokens.color.blue600};
  }
  .MuiButton-containedPrimary {
    background-color: ${UX.tokens.color.blue600};
  }
  .MuiButton-containedPrimary:hover {
    background-color: ${UX.tokens.color.blue700};
  }
  .MuiButton-outlinedPrimary {
    color: ${UX.tokens.color.blue600};
    border-color: ${UX.tokens.color.blue600};
  }
  .MuiButton-textPrimary {
    color: ${UX.tokens.color.blue600};
  }
  .MuiOutlinedInput-input,
  .MuiSelect-select {
    font-size: 16px;
    font-weight: ${UX.tokens.font.weightScale.regular};
    color: ${UX.tokens.color.black};
  }
  .MuiOutlinedInput-input::placeholder {
    font-size: 16px;
    font-weight: ${UX.tokens.font.weightScale.regular};
    color: ${UX.tokens.color.grey700};
    opacity: 1;
  }
`;
